export default "__VITE_ASSET__7UUJF3QT__"